import { Course } from '@models/course.model';
import { ILTCourse } from '@models/ilt-course.model';
import { LearningPath } from '@models/learning-path.model';

import { TranslatableTraining } from './training-translations.controller';

// The polymorphic `training_type` the backend stores per training class.
export const TRAINING_TYPES = {
  COURSE: 'Course',
  ILT_COURSE: 'IltCourse',
  LEARNING_PATH: 'LearningPath',
} as const;

export type TrainingType = (typeof TRAINING_TYPES)[keyof typeof TRAINING_TYPES];

/**
 * Whether a value is one of the three translatable training models. Lets components
 * holding a wider union (filter resources, tables) opt into translated display.
 */
export function isTranslatableTraining(
  value: unknown,
): value is TranslatableTraining {
  return (
    value instanceof Course ||
    value instanceof ILTCourse ||
    value instanceof LearningPath
  );
}

/**
 * The `training_type` discriminator of a training model, or null when the value is
 * not one of the three translatable trainings (e.g. a bare stub in a test).
 */
export function trainingTypeOf(
  training: TranslatableTraining | null | undefined,
): TrainingType | null {
  if (training instanceof Course) {
    return TRAINING_TYPES.COURSE;
  }
  if (training instanceof ILTCourse) {
    return TRAINING_TYPES.ILT_COURSE;
  }
  if (training instanceof LearningPath) {
    return TRAINING_TYPES.LEARNING_PATH;
  }
  return null;
}
